import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';
import LocationWorkerType from '@/models/LocationWorkers/LocationWorkerType';

export default class UpdateLocationWorkerRequest extends BaseUpdateRequest {
    type: LocationWorkerType;
    locationWorkerId: string;
    locationId: string;
}